import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-leilao01',
  templateUrl: './leilao01.component.html',
  styleUrls: ['./leilao01.component.scss']
})
export class Leilao01Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) {}
 
  ngOnInit(){
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }
}
